import React from 'react';
import LocationTemplate from './LocationTemplate';

const GoldsboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Goldsboro"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["27530", "27531", "27532", "27533", "27534"]}
      latitude={35.3849}
      longitude={-77.9928}
      population={35063}
      historicalFact="Established as Waynesborough in 1787, later relocated and renamed; site of significant Civil War activity."
      nearbyTowns={[
        "Wilson, NC",
        "Kinston, NC",
        "Mount Olive, NC",
        "Fremont, NC",
        "Pikeville, NC",
        "Dudley, NC",
        "Raleigh, NC",
        "Greenville, NC"
      ]}
    />
  );
};

export default GoldsboroPage;